import { useEffect } from "react";
import { toast, cssTransition } from "react-toastify";
import "./InternetStatusListener.css";

const linearTransition = cssTransition({
	enter: "Toastify__linear-enter",
	exit: "Toastify__linear-exit",
});

/**
 * Listens for offline/online events and shows toast notifications.
 * Shows "Internet is not connected" when the browser goes offline.
 */
const InternetStatusListener = () => {
	useEffect(() => {
		const handleOffline = () => {
			toast.dismiss("internet-online");
			toast.error("Offline. Trying to reconnect.", {
				autoClose: false,
				toastId: "internet-offline",
				closeOnClick: false,
				transition: linearTransition,
			});
		};

		const handleOnline = () => {
			toast.dismiss("internet-offline");
			toast.success("Connection restored. You’re back online.", { autoClose: 1000, toastId: "internet-online", transition: linearTransition });
		};

		// Show offline toast immediately if already offline on mount
		if (typeof navigator !== "undefined" && !navigator.onLine) {
			handleOffline();
		}

		window.addEventListener("offline", handleOffline);
		window.addEventListener("online", handleOnline);

		return () => {
			window.removeEventListener("offline", handleOffline);
			window.removeEventListener("online", handleOnline);
			toast.dismiss("internet-offline");
			toast.dismiss("internet-online");
		};
	}, []);

	return null;
};

export default InternetStatusListener;
